import React from 'react';
import './index.css'; // Import the CSS file for styling

const CircularProgressBar = (props) => {
    const { progress, size, strokeWidth, color, children } = props;
    // Calculate the circle radius and circumference
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;

    // Calculate the strokeDashoffset based on the progress
    const strokeDashoffset = circumference - (progress / 100) * circumference;

    return (
        <div
            className="circular-progress-container"
            style={{ width: size, height: size, position: 'relative' }}
        >
            <svg
                width={size}
                height={size}
                className="circular-progress-bar"
                style={{ transform: 'rotate(-90deg)' }}
            >
                <circle
                    className="circular-progress-bar-bg"
                    stroke="transparent"
                    fill="none"
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    strokeWidth={strokeWidth}
                />
                <circle
                    className="circular-progress-bar-fg"
                    stroke={color}
                    fill="none"
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    strokeWidth={strokeWidth}
                    strokeDasharray={circumference}
                    strokeDashoffset={strokeDashoffset}
                    strokeLinecap="round" // Optional: round end caps
                />
            </svg>
            <div
                className="inner-button"
                style={{width: size - 1}}
            >
                {children}
            </div>
        </div>
    );
};

export default CircularProgressBar;
